import type {Result, UseCase} from 'framework';
import type {BodyMeasurementsError} from '../../domain/errors';
import type {MeasurementEntry, MeasurementEntryId} from '../../domain/measurement-entry';
import type {BodyMeasurementsRepository} from '../ports/body-measurements.repository';

export type UpdateMeasurementEntryInput = {
  readonly entryId: MeasurementEntryId;
  readonly valueCm: number;
};

export class UpdateMeasurementEntry implements UseCase<
  [UpdateMeasurementEntryInput],
  MeasurementEntry
> {
  constructor(private readonly repository: BodyMeasurementsRepository) {}

  execute(
    input: UpdateMeasurementEntryInput,
  ): Promise<Result<MeasurementEntry, BodyMeasurementsError>> {
    return this.repository.updateEntry(input.entryId, input.valueCm);
  }
}
